export const galleryItems = [
  {
    id: 'bobs-plumbing',
    title: "Bob's Plumbing",
    screenshot: '/gallery/bobs-plumbing.png',
    liveUrl: 'https://fascinating-sopapillas-39f7a9.netlify.app',
    cost: '$99',
    time: '12 min'
  },
  {
    id: 'old-favorites',
    title: 'Old Favorites 101',
    screenshot: '/gallery/old-favorites.png',
    liveUrl: 'https://waitlist-0bb88990.pages.dev',
    cost: '$29',
    time: '6 min'
  },
  {
    id: 'big-smith',
    title: 'Big Smith Cleaning',
    screenshot: '/gallery/big-smith.png',
    liveUrl: 'https://professional-e97ab16e.pages.dev',
    cost: '$39',
    time: '8 min'
  },
  {
    id: 'sunday-drifters',
    title: 'The Sunday Drifters',
    screenshot: '/gallery/sunday-drifters.png',
    liveUrl: 'https://landing-55297ed8.pages.dev',
    cost: '$49',
    time: '8 min'
  },
  {
    id: 'happy-pets',
    title: 'Happy Pets',
    screenshot: '/gallery/happy-pets.png',
    liveUrl: 'https://happy-pets-dog-walking-79bad9ec.pages.dev',
    cost: '$49',
    time: '7 min'
  },
  {
    id: 'real-estate-listing',
    title: 'Real Estate Listing — 555 Fakes St',
    screenshot: '/gallery/real-estate-listing.png',
    liveUrl: 'https://real-estate-listing-e7700d50.pages.dev/',
    cost: '$49',
    time: '8 min'
  }
];
